<div class="faq">
  <app-gradient class="gradient gradient__left"></app-gradient>
  <app-gradient class="gradient gradient__right"></app-gradient>
  <section class="faq__container">
    <header class="faq__container-header">
      <h1 class="heading-m faq__title body-xl-bold">
        {{ 'faq.title' | translate }}
      </h1>
      <span class="body-m faq__subtitle">
        {{ 'faq.subtitle' | translate }}
        <a class="contact-us" [routerLink]="['/contact']">{{'faq.contact-us' | translate }}</a>
      </span>
    </header>
    <div class="faq__container-content">
      <ul class="faq__categories">
        @for (category of faqService.faqCategories(); track category) {
          <li
            class="faq__category"
            [ngClass]="{'faq__category--active body-l-bold': faqService.activeCategory() === category.id}"
            (click)="selectCategory(category.id)">
            {{ category.name }}
          </li>
        }
      </ul>
      <div class="faq__list">
        @for (item of faqService.faqs(); track item) {
          <div class="faq__item" [class.display-none]="item.category !== faqService.activeCategory()">
            <mat-accordion multi="false">
              <app-expansion-panel
                [content]="item.answer"
                [shouldPanelOpen]="openQuestion.id === item.id"
                (click)="openPanel(item)"
                [customClass]="'faq'"
                [title]="item.question">
              </app-expansion-panel>
            </mat-accordion>
          </div>
        }

      </div>
      <mat-accordion multi="false">
        @for (category of faqService.faqCategories(); track category) {
          <div class="faq__list__mobile">
            <app-expansion-panel-mobile
              [title]="category.name"
              (click)="selectCategory(category.id)">
            </app-expansion-panel-mobile>
          </div>
        }
      </mat-accordion>
    </div>
  </section>
</div>
